<template>
    <div>
        <portfolio-write-component :portfolio-type="'portfolioWrite'"></portfolio-write-component>
    </div>
</template>

<script>

import PortfolioWriteComponent from "../../components/portfolio/PortfolioWriteComponent";

export default {
    name: "Portfolio",
    mixins: [],
    components: {
        PortfolioWriteComponent
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>